<template>
  <el-dialog :visible.sync="visible" :width="width" :top="top" :fullscreen="fullscreen" class="esp_dialog"
             :class="showFooter?'esp_dialog_hasfooter':'esp_dialog_nofooter'" append-to-body @closed="closed"
             :close-on-click-modal="false">
    <div slot="title" class="title">
      <span>{{ title }}</span>
      <el-button class="full-btn" v-if="fullscreenBtn" type="text"
                 :icon="fullscreen?'iconfont icon-tuichuquanping':'iconfont icon-quanping'"
                 @click="full_screen"></el-button>
    </div>
    <el-scrollbar v-if="useScrollbar" class="esp_scrollbar" style="overflow-x: hidden">
      <div style="padding-top: 15px;padding-bottom: 10px;">
        <slot></slot>
      </div>
    </el-scrollbar>
    <slot v-else></slot>

    <div style="z-index: 1000;" slot="footer" v-if="showFooter">
      <el-button class="dialog-btn" type="primary" @click="doAction" size="small" :loading="loading">{{ okName }}
      </el-button>
      <el-button v-if="showCancel" class="dialog-btn" plain style="margin-left: 50px;" size="small" @click="doCancel">
        {{ cancelName }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'EspElDialog',
  data() {
    return {
      fullscreen: false,
      visible: false,
      loading: false //加载按钮的
    }
  },
  methods: {
    doAction() {
      if (this.showLoading) {
        this.loading = true;
      }
      this.$emit('doAction', result => {
        if (result == true) {
          this.visible = false;
        }
        this.loading = false;
      });
    },
    doCancel() {
      this.visible = false;
    },
    opened() {
      this.visible = true;
    },
    closed() {
      this.loading = false;
      this.$el.parentNode.removeChild(this.$el);
      this.$emit('closed', '')
    },
    full_screen() {
      if (!this.fullscreen) {
        var el = this.$el;
        var dialog = el.getElementsByClassName("el-dialog")[0];
        dialog.style.height = '100%';
      } else {
        var el = this.$el;
        var dialog = el.getElementsByClassName("el-dialog")[0];
        dialog.style.height = this.height;
      }
      this.fullscreen = !this.fullscreen
      this.$emit('fullscreen', '')
    }
  },
  props: {
    showCancel: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '对话框'
    },
    showFooter: {        //是否显示底部按钮
      type: Boolean,
      default: true
    },
    okName: {
      type: String,
      default: '确定'
    },
    cancelName: {
      type: String,
      default: '取消'
    },
    width: {
      type: String,
      default: '85%'
    },
    height: {
      type: String,
      default: '90%'
    },
    top: {
      type: String,
      default: "1vh"
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    isfullscreen: {       //是否全屏,true全屏，false不全屏
      type: Boolean,
      default: false
    },
    fullscreenBtn: {  //是否显示全屏按钮
      type: Boolean,
      default: false
    },
    useScrollbar: {         // 是否使用滚动条
      type: Boolean,
      default: true
    }
  },
  watch: {
    height: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          var el = this.$el;
          var dialog = el.getElementsByClassName("el-dialog")[0];
          if (!this.isfullscreen) {
            dialog.style.height = newVal;
          } else {
            dialog.style.height = '100%';
          }
        });
      },
      immediate: true
    },
    isfullscreen: {
      handler(newVal, oldVal) {
        this.fullscreen = newVal
      },
      immediate: true
    }
  },
  computed: {},
  created: function () {

  }
}
</script>


<style scoped>
.title {
  font-family: Helvetica Neue, Tahoma, PingFang SC, Hiragino Sans GB, Microsoft YaHei, STHeitiSC, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
  vertical-align: middle;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.full-btn {
  margin-right: 50px;
  font-size: 16px;
  color: #000000;
  font-weight: bold;
}

.dialog-btn {
  padding: 9px 27px;
}
</style>
<style>
.esp_dialog .el-dialog {
  min-height: 200px;
  max-height: 100%;
  margin: 0px !important;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  overflow: hidden;
}

.esp_dialog .el-dialog__header {
  position: relative;
  height: 50px;
  padding: 0px 10px !important;
  background-color: #f5f5f5;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
}

.esp_dialog .el-dialog__header .el-dialog__title {
  font-size: 13px;
  font-weight: 600;
}

.esp_dialog .el-dialog__header .el-dialog__headerbtn {
  top: 50% !important;
  right: 14px;
  transform: translate(-50%, -50%) !important;
}

.esp_dialog_hasfooter .el-dialog__body {
  /* padding: 10px 5px 10px 10px; */
  height: calc(100% - 120px) !important;
  overflow: hidden;
}

.esp_dialog_nofooter .el-dialog__body {
  /*padding: 10px 5px 10px 10px;*/
  height: calc(100% - 70px) !important;
  overflow: hidden;
  padding-bottom: 15px !important;
}

.esp_dialog .el-dialog__body .el-scrollbar__view {
  /* padding-right: 15px; */
}

.esp_dialog .el-dialog__footer {
  text-align: center !important;
  padding: 5px 10px 20px 10px !important;
  border-top: none !important;
  margin-top: 0px;
  /*z-index: 1000;*/
}

/* ----------------------弹框统一样式修改----------------------------------------- */
/* input框边框颜色 */
/* .esp_dialog .el-input__inner {
  border: 1px solid #BABABA;
} */
/* input框禁用样式 */
.esp_dialog .el-input.is-disabled .el-input__inner {
  background-color: #EAECEE;
  border-color: #BABABA;
  color: #A9A9A9;
}

/* 文本域边框 */
.esp_dialog .el-textarea__inner {
  border-color: #BABABA;
}

.esp_dialog .el-input-group__append, .el-input-group__prepend {
  border-color: #BABABA;
}

.esp_dialog .el-button--info.is-plain.is-disabled, .el-button--info.is-plain.is-disabled:hover, .el-button--info.is-plain.is-disabled:focus, .el-button--info.is-plain.is-disabled:active {
  background-color: #EAECEE;
  border-color: #BABABA;
  color: #A9A9A9;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/EspElDialog.vue